var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":_vm.id,"options":_vm.dropzoneOptions,"useCustomSlot":true,"include-styling":false},on:{"vdropzone-thumbnail":_vm.customThumbnail,"vdropzone-file-added":_vm.added}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }